import { AddIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

import { ArrowMappingIcon, TrashcanIcon } from '@assets/icons';
import SearchProduct from '@pages/UploadMappingV2/components/SearchProduct';
import { useMassalStore } from '@pages/UploadMappingV2/hooks/state/useAddProductMassal';
import { ConfirmationState2 } from '@assets/images';
import { useConfirmModal } from '@store/useConfirmModal';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';

export const tableHeadLists = [
    {
        key: 'name',
        title: 'Nama Bundle',
        width: '400px',
        tableDataList: ({ value }) => {
            return (
                <Box py={4}>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: '?',
        width: '400px',
        tableDataList: ({ value }) => {
            return (
                <Box py={4}>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'code',
        title: 'Kode Produk di Toko',
        width: '400px',
        tableDataList: ({ value }) => {
            return (
                <Box py={4}>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
];

function ActionHead({ allValue }) {
    const { toggleRow, expanded } = useApp();
    const { set } = useConfirmModal();
    const { startEditBundle, cancelEditBundle, deleteBundleItem } = useMassalStore();
    const handleConnect = () => {
        startEditBundle(allValue.id);
        toggleRow(allValue.id);
    };
    const handleCancel = () => {
        cancelEditBundle(allValue.id);
        if (expanded === allValue.id) {
            toggleRow(allValue.id);
        }
    };
    const handleDelete = () => {
        set({
            isOpen: true,
            title: 'Hapus product?',
            desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan atau menghubungkan produk.',
            btnLabelYes: 'Ya, Hapus',
            btnLabelNo: 'Kembali',
            ConfirmationStateImage: ConfirmationState2,
            onSubmit: () => deleteBundleItem(allValue.id),
        });
    };

    return (
        <Flex gap={'12px'}>
            {allValue.isEditing ? (
                <Button onClick={handleCancel} size={'sm'} variant={'outline'} w={'150px'}>
                    <AddIcon transform={'rotate(45deg)'} />
                    Batalkan
                </Button>
            ) : (
                <Button onClick={handleConnect} size={'sm'} w={'150px'}>
                    <AddIcon />
                    Hubungkan
                </Button>
            )}
            <Button variant={'outline'} onClick={handleDelete} size={'sm'}>
                <TrashcanIcon size={18} color="#215AA8" />
            </Button>
        </Flex>
    );
}

function ProductTokoCell({ value, allValue }) {
    const { expanded, toggleRow } = useApp();
    const { updateBarcodeBundle } = useMassalStore();
    const handlePassProductName = () => {
        updateBarcodeBundle(allValue.id, null, true);
        if (expanded !== allValue.id) {
            toggleRow(allValue.id);
        }
    };

    return (
        <Flex justifyContent="space-between" alignItems="center" gap={'8px'}>
            <Box>
                <Text>{value}</Text>
                <Text fontSize="12px" color="neutral.400">
                    {allValue.code}
                </Text>
            </Box>

            <Box onClick={handlePassProductName} cursor="pointer">
                <ArrowMappingIcon />
            </Box>
        </Flex>
    );
}

function ProductParagonCell({ allValue }) {
    return (
        <Box>
            {allValue.isEditing ? (
                <SearchProduct id={allValue.id} allValue={allValue} isPassing={allValue?.isPassing} type={'bundle'} />
            ) : (
                <Text color={'neutral.400'}>Produk belum terhubung</Text>
            )}
        </Box>
    );
}

export const tableHeadListsConnect = [
    {
        key: 'name',
        title: 'Produk Toko',
        width: '400px',
        tableDataList: ({ value, allValue }) => {
            return <ProductTokoCell value={value} allValue={allValue} />;
        },
    },
    {
        key: '?',
        title: 'Produk Paragon',
        width: '400px',
        tableDataList: ({ allValue }) => {
            return <ProductParagonCell allValue={allValue} />;
        },
    },
    {
        key: 'action',
        title: 'Action',
        width: '5%',
        tableDataList: ({ allValue }) => {
            return <ActionHead allValue={allValue} />;
        },
    },
];
